module.exports = __webpack_public_path__ + "static/media/Intro-after-trial.e99f5100.mp3";